// extracted by mini-css-extract-plugin
module.exports = {"googleOr":"googleOneTapConnect_googleOr__GKgOi"};